/**
 * Build-ID der ausgelieferten Frontend-Bundles.
 *
 * `__BUILD_ID__` wird von Vite zur Build-Zeit ersetzt (`define` in `vite.config.ts` und –
 * für Unit-Tests – in `vitest.config.ts`): ein ISO-8601-Zeitstempel des `vite build`-Laufs
 * (im Dev-Server: des Server-Starts). Deklariert in `src/env.d.ts`.
 */

/** Rohwert: ISO-8601-Zeitstempel (UTC) des Builds. */
export const BUILD_ID_ISO: string = __BUILD_ID__;

/**
 * Formatiert einen ISO-Zeitstempel als `YYYY-MM-DD HH:mm` in UTC (Docker-/CI-Builds laufen in
 * UTC, so sehen lokale und Image-Builds einheitlich aus). Ungültiger Input wird unverändert
 * zurückgegeben. Im Dev-Modus wird das Suffix ` dev` angehängt.
 */
export function formatBuildId(iso: string, dev: boolean): string {
    const suffix = dev ? ' dev' : '';
    const ms = Date.parse(iso);
    if (Number.isNaN(ms)) {
        return `${iso}${suffix}`;
    }
    const label = new Date(ms).toISOString().slice(0, 16).replace('T', ' ');
    return `${label}${suffix}`;
}

/** Anzeige-Label für den Header (rechts oben). */
export const BUILD_ID_LABEL: string = formatBuildId(BUILD_ID_ISO, import.meta.env.DEV);
